/**
 * Subscribe to a Mercure topic and dispatch reducer events for Supervision payloads.
 */
export default function bindMercureTopic(payload) {
  return function(dispatch, getState) {
    const state = getState();
    const binded = (state.webSockets && state.webSockets.bindedEvents) || [];
    const eventKey = payload.reducerEvent + ':' + payload.uid;

    if (binded.indexOf(eventKey) >= 0) {
      return null;
    }

    if (typeof EventSource === 'undefined') {
      console.error('EventSource is not available in this browser');
      return null;
    }

    const url = payload.mercureUrl
      + (payload.mercureUrl.indexOf('?') >= 0 ? '&' : '?')
      + 'topic=' + encodeURIComponent(payload.topic);

    const source = new EventSource(url);

    source.onmessage = (event) => {
      let data;
      try {
        data = JSON.parse(event.data);
      } catch (e) {
        return;
      }

      if (data.type === 'failure') {
        dispatch({
          type: 'RECEIVED_SUPERVISION_FAILURE',
          payload: { response: data }
        });
        return;
      }

      // Normalize: worker sends type=newData; front reducers expect phisics/etc at top level
      dispatch({
        type: payload.reducerEvent,
        payload: {
          request: payload,
          response: data
        }
      });
    };

    source.onerror = () => {
      // Browser will auto-reconnect; surface once
      dispatch({
        type: 'MERCURE_CONNECTION_ERROR',
        payload: { uid: payload.uid }
      });
    };

    dispatch({
      type: 'WEBSOCKET_EVENT_BINDED',
      payload: {
        eventName: eventKey,
        source: source
      }
    });

    dispatch({
      type: 'WEBSOCKET_CONNECTED',
      payload: { io: { mercureSource: source } }
    });

    return source;
  };
}
